import { defineAsyncComponent } from 'vue'
export default {
  "empty-layout": defineAsyncComponent(() => import("/nuxtWeb/layouts/EmptyLayout.vue").then(m => m.default || m)),
  "user-layout": defineAsyncComponent(() => import("/nuxtWeb/layouts/UserLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/nuxtWeb/layouts/default.vue").then(m => m.default || m)),
  preview: defineAsyncComponent(() => import("/nuxtWeb/layouts/preview.vue").then(m => m.default || m)),
  qiankun: defineAsyncComponent(() => import("/nuxtWeb/layouts/qiankun.vue").then(m => m.default || m))
}